// Phase 3 - US1: Profile Types
// T048: Frontend profile data types

export enum Gender {
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum EducationLevel {
  FUNDAMENTAL = 'FUNDAMENTAL',
  MEDIO = 'MEDIO',
  SUPERIOR = 'SUPERIOR',
  POS_GRADUACAO = 'POS_GRADUACAO',
  MESTRADO = 'MESTRADO',
  DOUTORADO = 'DOUTORADO',
}

export enum EconomicLevel {
  NO_INCOME = 'NO_INCOME', // Sem rendimento
  UP_TO_HALF_MW = 'UP_TO_HALF_MW', // Até ½ SM
  ONE_TO_TWO_MW = 'ONE_TO_TWO_MW', // 1 a 2 SM
  TWO_TO_FIVE_MW = 'TWO_TO_FIVE_MW', // 2 a 5 SM
  FIVE_TO_TEN_MW = 'FIVE_TO_TEN_MW', // 5 a 10 SM
  TEN_TO_TWENTY_MW = 'TEN_TO_TWENTY_MW', // 10 a 20 SM
  ABOVE_TWENTY_MW = 'ABOVE_TWENTY_MW', // Acima de 20 SM
}

export interface City {
  id: string;
  name: string;
  ibgeCode: string;
  stateId: string;
  state?: State;
}

export interface State {
  id: string;
  name: string;
  code: string;
  countryId: string;
  country?: Country;
  cities?: City[];
}

export interface Country {
  id: string;
  name: string;
  code: string;
}

export interface ParticipantProfile {
  id: string;
  userId: string;
  preferredName: string;
  phone: string;
  phoneVerified?: boolean;
  gender: Gender;
  dateOfBirth: string;
  educationLevel: EducationLevel;
  economicLevel: EconomicLevel;
  cityId: string;
  city?: City;
  neighborhood: string;
  lastUpdatedAt: string;
  profileVersion: number;
  isStale?: boolean;
}

export interface CreateProfileData {
  gender: Gender;
  dateOfBirth: string;
  educationLevel: EducationLevel;
  economicLevel: EconomicLevel;
  cityId: string;
  neighborhood: string;
}

export interface UpdateProfileData extends Partial<CreateProfileData> {
  preferredName?: string;
  phone?: string;
  stateId?: string; // Optional, only used in form for city selection
  city?: City; // Optional, may be included when loading edit data
}
